module.exports = __webpack_public_path__ + "static/img/bannermin.bdf8a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bannermin.jpg
// module id = Tucp
// module chunks = 1